import React from 'react';
import { useWallet } from '../contexts/WalletContext';
import { Button } from 'react-bootstrap';
import { useConnect } from 'wagmi';

export function WalletConnect() {
  const { isConnected, address, isConnecting, error, disconnectWallet } = useWallet();
  const { connect, connectors } = useConnect();

  const formatAddress = (addr) => {
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  if (isConnected && address) {
    return (
      <div className="wallet-connected">
        <div className="wallet-info" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ color: '#00D1FF' }}>●</span>
          <span style={{ color: '#00D1FF' }}>{formatAddress(address)}</span>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={disconnectWallet}
          >
            Disconnect
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="wallet-connect">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {connectors.map((connector) => (
          <Button
            key={connector.id}
            variant="primary"
            onClick={() => connect({ connector })}
            disabled={isConnecting}
            style={{ fontSize: '2em' }}
          >
            {isConnecting ? 'Connecting...' : `Connect ${connector.name}`}
          </Button>
        ))}
      </div>
      {error && (
        <div style={{ color: '#FF6B6B', marginTop: '10px' }}>
          {error}
        </div>
      )}
    </div>
  );
}

